import { ReactElement, ReactNode } from 'react'

import { Flex } from '../Flex'
import { Icon, IconName } from '../Icon'
import { IconButton } from '../IconButton'
import { Space } from '../Space'
import { Text } from '../Text'
import * as Styled from './styles'
import { Variant } from './types/variant'
import { variantStyles } from './utils/variantStyles'

export interface AlertProps {
  className?: string
  children: ReactNode
  closable?: boolean
  icon?: IconName
  onClose?: () => void
  showIcon?: boolean
  sideActions?: ReactNode
  variant?: Variant
}

export const Alert = ({
  children,
  closable,
  className,
  icon: customIcon,
  onClose,
  showIcon = true,
  sideActions,
  variant = 'warning',
}: AlertProps): ReactElement => {
  const icon = customIcon || variantStyles[variant].icon
  const variantTextColor = variantStyles[variant].color

  return (
    <Styled.AlertWrapper className={className} role="alert" variant={variant}>
      <Styled.Alert justifyContent="center">
        <Flex alignItems="center" flexGrow={1} justifyContent="center">
          {closable && <Space horizontal size="s40" />}
          {showIcon && (
            <Styled.IconWrapper>
              <Icon color={variantTextColor} icon={icon} />
            </Styled.IconWrapper>
          )}
          <Text color={variantTextColor}>{children}</Text>
        </Flex>
        {sideActions && <Styled.SideActions>{sideActions}</Styled.SideActions>}
        {closable && (
          <Styled.IconCloseWrapper>
            <IconButton color={variantTextColor} onClick={onClose} size="sm" icon="x" />
          </Styled.IconCloseWrapper>
        )}
      </Styled.Alert>
    </Styled.AlertWrapper>
  )
}
